export const hayaOrder = <T>(data: T[]): T[] => {
	if (data.find((bt: any) => bt.type_id === '7') !== undefined) {
		let hayaType: T = data.filter((d: any) => d.type_id === '7')[0];
		data = data.filter((d: any) => d.type_id !== '7');
		data = [hayaType, ...data];
	}
	return data;
};
